import  {Message} from "element-ui";
import {Toast} from "vant";

let _copyUrl = {
    copyUrl: function (val) {
        var cInput = document.createElement("input");
        cInput.value = val;
        document.body.appendChild(cInput);
        cInput.select(); // 选取文本框内容
        document.execCommand("copy");
        Message({
            type: "success",
            message: '复制成功'
        });
        // 复制成功后再将构造的标签 移除
        document.body.removeChild(cInput);
    },
    custom_copyUrl: function (val) {
        var cInput = document.createElement("input");
        cInput.value = val;
        document.body.appendChild(cInput);
        cInput.select(); // 选取文本框内容
        document.execCommand("copy");
        // 复制成功后再将构造的标签 移除
        document.body.removeChild(cInput);
    },

}

export  default _copyUrl
